import {linkItems} from "@/components/Header/types";

export default defineNuxtPlugin(() => {
  const route = useRoute();

  //Redirect to root path if current route is not root path after page reload
  if (route.fullPath !== linkItems.root.routerPath) {
    window.location.href = linkItems.root.routerPath;
  }
});